/**
 * Single source of brand strings. Every component that renders a brand
 * attribute (logo, footer, OG image, sitemap, RSS, llms.txt, etc.) imports
 * from here. Never hard-code the name anywhere else.
 *
 * Null-by-default rules:
 *  - `social.*` and `author.url/avatarUrl` and `repo.org/name/baseUrl` render
 *    only when non-null. Do not invent handles, repos, or personal URLs.
 *  - `repo.org` and `repo.name` are required before the first `tofu apply`
 *    because the OIDC trust policy hard-codes the GitHub owner/repo.
 */
export type SiteConfig = {
  name: string;
  shortName: string;
  domain: string;
  url: string;
  description: string;
  ogImageDefault: string;
  rssTitle: string;
  rssDescription: string;
  author: {
    name: string;
    handle: string;
    url: string | null;
    avatarUrl: string | null;
    jobTitle?: string;
    knowsAbout?: string[];
    description?: string;
  };
  repo: {
    org: string | null;
    name: string | null;
    baseUrl: string | null;
  };
  social: {
    github: string | null;
    twitter: string | null;
    linkedin: string | null;
    rss: string;
  };
  copyright: {
    contentLicense: string;
    codeLicense: string;
    year: number;
  };
};

export const siteConfig: SiteConfig = {
  name: 'AI Evals',
  shortName: 'AI Evals',
  domain: 'aievals.co',
  url: 'https://www.aievals.co',
  description: 'The most useful, opinionated reference for AI evals.',
  ogImageDefault: '/og/default.png',
  rssTitle: 'AI Evals',
  rssDescription: 'Recent updates from aievals.co',
  author: {
    name: 'Om Bharatiya',
    handle: '@ombharatiya',
    url: 'https://www.linkedin.com/in/ombharatiya/',
    avatarUrl: null,
    jobTitle: 'Principal AI Engineer',
    knowsAbout: [
      'LLM evaluation',
      'AI evals',
      'RAG evaluation',
      'LLM-as-judge',
      'AI agent evaluation',
      'production LLM monitoring',
    ],
    description:
      'Author of aievals.co. Ships LLM products and writes about how to evaluate them.',
  },
  repo: {
    org: 'ombharatiya',
    name: 'evals',
    baseUrl: null,
  },
  social: {
    github: 'https://github.com/ombharatiya',
    twitter: 'https://x.com/ombharatiya',
    linkedin: 'https://www.linkedin.com/in/ombharatiya/',
    rss: '/rss.xml',
  },
  copyright: {
    contentLicense: 'CC BY 4.0',
    codeLicense: 'MIT',
    year: 2026,
  },
};

export default siteConfig;
